import { getPushCategoryEventHandler } from './AnalyticsGAHelpers';

const CATEGORY = 'navigation_events';

enum Actions {
  EXPAND_CATEGORY_MENU = 'expand_category_menu',
  EXPAND_MAIN_MENU = 'expand_main_menu',
  SELECT_CATEGORY = 'select_category',
  SELECT_PRODUCTS_CAROUSEL = 'select_product_carousel',
  VIEW_NAVIGATION_BUTTON = 'view_navigation_button',
  SELECT_NAVIGATION_BUTTON = 'select_navigation_button',
  VIEW_MENU_BUTTON = 'view_menu_button',
  SELECT_MENU_BUTTON = 'select_menu_button',
}

const push = getPushCategoryEventHandler<Actions>(CATEGORY);

// Events

export function expandCategoryMenu() {
  push(Actions.EXPAND_CATEGORY_MENU);
}

export function expandMainMenu() {
  push(Actions.EXPAND_MAIN_MENU);
}

export function selectCategory(name: string) {
  push(Actions.SELECT_CATEGORY, name);
}

export function selectProductsCarousel(name: string) {
  push(Actions.SELECT_PRODUCTS_CAROUSEL, name);
}

export function viewNavigationButton(title: string) {
  push(Actions.VIEW_NAVIGATION_BUTTON, title);
}

export function selectNavigationButton(title: string) {
  push(Actions.SELECT_NAVIGATION_BUTTON, title);
}

export function viewMenuButton(title: string) {
  push(Actions.VIEW_MENU_BUTTON, title);
}

export function selectMenuButton(title: string) {
  push(Actions.SELECT_MENU_BUTTON, title);
}
